import { IAppState, ITrackingData } from '../common/state';
import { prepareTrackingData } from '../utils/prepareTrackingData';

export function getTrackingData(state: IAppState): ITrackingData {
  const { results, user, breadcrumbs } = state;

  return prepareTrackingData(results, breadcrumbs, user);
}
